<template>
  <div class="row">
    <div class="course-content-editor-container  small-12 columns">
      <div
        class="close-button absolute cursor-pointer"
        title="Close (Esc)"
        @click="$emit('CLOSE_MODAL')"
      >
        ❌
      </div>
      <div class="small-12 columns">
        <div><h2>Module Addition</h2></div>
        <div class="small-3 columns">Module Name</div>
        <div class="small-9 columns">
          <input
            v-model="moduleObject.name"
            class="module-input-box input-box-course-creators"
            type="text"
          />
        </div>
        <div class="small-12 columns">
          <div class="small-3 columns">is Module Required</div>
          <div class="small-6 columns">
            <input
              v-model="moduleObject.is_required"
              type="checkbox"
              @click="handleCheckboxChange($event, 'is_required')"
            />
          </div>
        </div>
        <div class="small-12 columns">
          <div class="small-3 columns">Is Payment Locked</div>
          <div class="small-6 columns">
            <input v-model="moduleObject.is_payment_locked" type="checkbox" />
          </div>
        </div>
        <div class="small-12 columns">
          <div class="small-3 columns">Is Dependent IDs</div>
          <div class="small-9 columns">
            <multiselect
              v-model="selected"
              :taggable="true"
              :options="modules"
              label="name"
              :multiple="true"
              @remove="removeTag"
            />
          </div>
        </div>

        <div class="small-12 columns">
          <div class="small-3 columns">Phase</div>
          <div class="small-9 columns">
            <VueSelect
              class="mb-2 bg-white"
              placeholder="Select a Phase"
              :options="phaseOptions"
              label="name"
              :reduce="option => option.name"
              @input="option => (moduleObject.phase_id = option.id)"
            />
          </div>
        </div>

        <div class="small-12 columns">
          <div class="row">
            <div class="small-3 columns">is Module Bonus</div>
            <div class="small-9 columns">
              <input
                v-model="moduleObject.is_bonus"
                type="checkbox"
                @click="handleCheckboxChange($event, 'is_bonus')"
              />
            </div>
          </div>
        </div>
        <div class="small-12 columns">
          <button
            class="border border-green bg-green text-white py-2 px-4 rounded-sm"
            @click="createModule"
          >
            Create Module
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import Multiselect from "vue-multiselect"
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"

export default {
  components: { Multiselect, VueSelect },
  props: ["modules", "phaseOptions", "is_required", "is_bonus"],
  data() {
    return {
      selected: [],
      moduleObject: {
        name: "",
        is_payment_locked: true,
        is_required: true,
        is_bonus: false,
      },
    }
  },
  created() {
    // restore previously selected state
    this.moduleObject.is_required = this.is_required
    this.moduleObject.is_bonus = this.is_bonus
  },
  mounted() {},
  methods: {
    ...mapActions("module", [
      "UPDATE_MODULE",
      "LOAD_CURRENT_COURSES_EDITING_STATE",
    ]),
    handleCheckboxChange(e, name) {
      const payload = {}
      payload[name] = e.target.checked // the key is dynamic
      this.$emit("CHECKBOX_STATE_CHANGE", payload)
    },
    removeTag(tag) {
      let index
      for (let i = 0; i < this.selected.length; i++) {
        if (this.selected[i].id === tag.id) {
          index = i
        }
      }
      this.selected = this.selected.splice(index, 1)
    },
    createModule() {
      const modulecreatorloader = this.$loading.show()
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}admin/modules`,
        data: this.moduleObject,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          modulecreatorloader.hide()
          this.moduleObject.is_dependent_ids = this.selected.map(
            item => item.id
          )
          this.$emit(
            "MODULE_CREATED",
            res.data,
            this.moduleObject.is_dependent_ids,
            this.moduleObject.phase_id
          )
        })
        .catch(() => {
          modulecreatorloader.hide()
        })
    },
  },
}
</script>

<style>
.module-input-box {
  border: 1px solid black;
}
</style>
